import { createAsyncAction, createReducer} from 'typesafe-actions'
import { END } from 'redux-saga'
import { put, call, takeEvery, all } from 'redux-saga/effects';
import * as api from '../lib/api/subscriptions'
import { FormSettings, VarsSettings, ArchiveSetting } from '../pages/types';
import { AxiosError } from 'axios';

export type subscriptionsInfoPayloadType = {
  formSettings: FormSettings
  varsSettings: VarsSettings
  archiveSetting: ArchiveSetting
}

export type getSubscriptionsInfoState ={
  data: subscriptionsInfoPayloadType
  loading : boolean
  error: boolean
  errorData?:AxiosError
}

export const getSubscriptionsInfo = createAsyncAction(
  'GET_SUBSCRIPTIONS_INFO',
  'GET_SUBSCRIPTIONS_INFO_SUCCESS',
  'GET_SUBSCRIPTIONS_INFO_FAILURE',
)<string, any, AxiosError>();

type subscriptionsInfoAction = ReturnType<typeof getSubscriptionsInfo.request>

const initialState: getSubscriptionsInfoState = {
  data:{
    formSettings:{
      buttonColor: "",
      buttonTextColor: "",
      fieldbutton: false,
      formButton: "",
      formDescription: '',
      formDescriptionShow: false,
      formHeaderImage: "",
      formIsActive: "Y",
      formPolicy: "",
      formPolicyShow: false,
      formReCaptchaShow: false,
      formTitle: "",
      formTitleShow: false,
      formAdAgreementShow:false,
      formAdAgreement:'',
      },
    varsSettings:[],
    archiveSetting:{
      formHeaderImageShow: false,
      formHeaderImage: '',
      formTitleShow: false,
      formTitle: '',
      formDescriptionShow: false,
      formDescription: ''
    }
},
  loading:false,
  error:false,
}

function* getSubscriptionsInfoSaga(action:subscriptionsInfoAction):Generator{
  try {
    const response:any = yield call(
      api.getListPage,
      action.payload
    )
    yield put(getSubscriptionsInfo.success(response.data))
  } catch (e) {
    yield put(getSubscriptionsInfo.failure(e))
  }
}

export function* subscriptionsInfoSaga(){
  yield all([takeEvery(getSubscriptionsInfo.request, getSubscriptionsInfoSaga)])
}

export const subscriptionsInfo = createReducer<
  getSubscriptionsInfoState,
  ReturnType<typeof getSubscriptionsInfo.request>|
  ReturnType<typeof getSubscriptionsInfo.success>|
  ReturnType<typeof getSubscriptionsInfo.failure>|
  END
>(initialState)
  .handleAction(
    getSubscriptionsInfo.request,
    (state:getSubscriptionsInfoState,action:{payload:string}
      )=>({
        ...state,
        loading: true,
        error: false,
      })
  )
  .handleAction(
    getSubscriptionsInfo.success,
    (state:getSubscriptionsInfoState,action:{payload:subscriptionsInfoPayloadType})=>({
      ...state,
      loading: false,
      data:action.payload,
    })
  )
  .handleAction(
    getSubscriptionsInfo.failure,
    (state:getSubscriptionsInfoState,action:{payload:AxiosError})=>({
      ...state,
      loading:false,
      error:true,
      errorData: action.payload 
    })
  )

  export default subscriptionsInfo